import { h } from "vue";
import NameCell from "@/components/StudentFulfillment/components/modals/BookingFulfillmentModal/TableCells/NameCell.vue";
import { format as formatDate, parseISO } from "date-fns";

export const columnsConfig = [
  {
    id: "id",
    header: "Order ID",
    size: 100,
    type: "radio",
    getColumnDisplayValue: ({ order }) => order?.id ?? "",
  },
  {
    id: "student_name_and_email",
    header: "Student Name and Email",
    size: 50,
    cell: (data) =>
      h(NameCell, {
        data: {
          participant_fullname:
            data?.row?.original?.order?.participant_fullname ?? "",
          participant_email:
            data?.row?.original?.order?.participant_email ?? "",
        },
        stylesClasses: ["font-semibold", "text-teal-900 lowercase"],
      }),
    getColumnDisplayValue: ({ order }) =>
      `${order.participant_fullname} ${order?.participant_email}` ?? "",
  },
  {
    id: "program_name",
    header: "Program Name",
    size: 50,
    cell: (data) =>
      h(NameCell, {
        data: {
          session_name: data?.row?.original?.order?.session?.name ?? "",
          home_institution_name:
            data?.row?.original?.order?.home_institution_name ?? "",
        },
        stylesClasses: ["text-teal-900 font-semibold", ""],
      }),
    getColumnDisplayValue: ({ order }) => order?.session?.name ?? "",
  },
  {
    id: "program_dates",
    header: "Program Dates",
    size: 50,
    getColumnDisplayValue: ({ order }) =>
      `${formatDate(
        parseISO(order?.session?.start_date),
        "MM/dd/yyyy"
      )} - ${formatDate(parseISO(order?.session?.end_date), "MM/dd/yyyy")}` ??
      "",
  },
  {
    id: "session",
    header: "Session",
    size: 50,
    getColumnDisplayValue: ({ order }) =>
      order?.session?.terms.map((term) => term?.name).join(", ") ?? "",
  },
  {
    id: "order_status",
    header: "Order Status",
    size: 50,
    getColumnDisplayValue: ({ order }) => order?.status ?? "",
  },
];
